var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 19,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.004 0h-.008A9.004 9.004 0 1 0 19 8.996 8.996 8.996 0 0 0 10.004 0Zm4.682 7.231h.016l-5.42 5.428a1.059 1.059 0 0 1-1.49 0l-2.494-2.502A1.051 1.051 0 0 1 6.78 8.675l1.757 1.749 4.706-4.66a1.035 1.035 0 0 1 1.482 0c.387.42.37 1.07-.039 1.467Z"
})));

export default SvgCheck;